import reportReducer from './reducers/report.js';

export default {
    report: {
        reducer: reportReducer,
    },
};
